import { useContext } from 'react';

import { InboxLiveContext, type InboxLive } from '../lib/inbox-live-context';

/** The inbox socket of the surrounding inbox layout (or a polling stand-in outside one). */
export function useInboxLive(): InboxLive {
  return useContext(InboxLiveContext);
}
